import React from 'react'
import { formatDate, formatMoney } from '../../utils/formatter'
import ResponsiveModal from '../layout/ResponsiveModal'
import './styles/TransactionModal.css'

export default function PaymentModal({ visible, transaction, close }) {
  const {
    transactionId, transactionType, grossAmount,
    deliveryPartnerCharges, gateWayCharges, totalCharges,
    netAmount, customer, transactionStatus, postedOn,
    sokolinkCharges, transactionDetails,
  } = transaction
  const isPayment = transactionType === 'payment'
  return (
    <>
      <ResponsiveModal visible={visible} title="Transaction Details" cancellable cancel={close}>
        <div className="transaction-modal">
          <h5>{`Transaction Id:  ${transactionId}`}</h5>
          <p>{`Transaction Type: ${transactionType}`}</p>
          <p>
            Transaction Status:
            <span className={transactionStatus}>{transactionStatus}</span>
          </p>
          <p>{`Gross Amount: ${formatMoney(grossAmount)}`}</p>
          <p>{`Sokolink Charges: ${formatMoney(sokolinkCharges)}`}</p>
          <p>{`Payment Gateway Charges: ${formatMoney(gateWayCharges)}`}</p>
          <p>{`Delivery Partner Charges: ${formatMoney(deliveryPartnerCharges)}`}</p>
          <p>{`Total Charges: ${formatMoney(totalCharges)}`}</p>
          <p>{`Net Amount: ${formatMoney(netAmount)}`}</p>
          {isPayment && customer ? <p>{`Customer Name:  ${customer?.name}`}</p> : null }
          {isPayment && customer ? <p>{`Customer Phone:  ${customer?.phone}`}</p> : null }
          <p>{`Date: ${formatDate(postedOn)}`}</p>
          <p>{transactionDetails}</p>
        </div>
      </ResponsiveModal>
    </>
  )
}
